import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { StatsCard, StatsProps } from "./Stats.d";

export const StatsPart = (props: ComponentProps<PartData>) => {
  const { listStatsCards = [] } =
    (props.data as StatsProps) ?? {};


  return (
    <section className="statistics">
          <div className="statistics__cards">
            {listStatsCards.map((card: StatsCard, idx: number) => (
              <div key={idx} className="statistics__card">
                <p className="statistics__card-title">{card.title}</p>
                {card.description && (
                  <p className="statistics__card-description">{card.description}</p>
                )}
              </div>
            ))}
          </div>
    </section>
  );
};

export default StatsPart;